import {
    InjectedProps as WithRouterPathProps,
    mediaQueryResolver,
    SCREEN_SIZE,
    WithMediaQueryResolverProps,
    withRouterPath,
} from 'platform-components/hocs';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { getCurrentClass } from 'common.components/user/selectors';
import * as themesSelectors from 'store/themes/selectors';

// @ts-ignore
import BREAKPOINTS from '../../../../design/breakpoints.scss';
import { ReduxTeacherStore } from '../../typings';
import { SCREEN_QUERY } from '../library.sidebar/constants';

import Column from './__column/section-menu__column';
import { getBestSplitPoints, splitByPoints } from './utils';

import './section-menu.scss';

const ROWS_COUNT_DESKTOP = 3;
const ROWS_COUNT_MOBILE = 2;

interface StoreProps {
    menuThemes: ReturnType<typeof themesSelectors.getThemesTree>;
}

interface OwnProps {
    isActualThemes?: boolean;
}

interface HOCProps extends WithRouterPathProps, WithMediaQueryResolverProps {}

interface Props extends HOCProps, StoreProps, OwnProps {}

const TITLE_BIGGER_THAN_CHILDREN_TIMES = 3;

export class SectionMenu extends React.Component<Props> {
    render() {
        const { menuThemes, isActualThemes, screenSize } = this.props;

        if (menuThemes === null || menuThemes.length === 0) {
            return null;
        }

        const isMobile = screenSize === SCREEN_SIZE.MEDIUM;

        const blockSizes = menuThemes.map((theme) => {
            const childrenLength = theme.children.length;

            return childrenLength + TITLE_BIGGER_THAN_CHILDREN_TIMES;
        });

        const chunksCount = isMobile ? ROWS_COUNT_MOBILE : ROWS_COUNT_DESKTOP;
        const splitPoints = getBestSplitPoints(blockSizes, chunksCount);

        const splittedContent = splitByPoints(menuThemes, splitPoints);
        const tooltipDescriptions =
            splittedContent.length > 1 && splittedContent[1].length
                ? [
                      'library.actualThemes.tooltip.personalCollection',
                      'library.actualThemes.tooltip.smartRepetition',
                      'library.actualThemes.tooltip.weekTopic',
                  ]
                : ['library.actualThemes.tooltip.weekTopic'];

        return (
            <div className="section-menu">
                <div className="section-menu__content">
                    {splittedContent.map((content, index: number) => (
                        // в данном случе можем использовать индекс для ключа,
                        // т.к. суперменю всегда состоит из 3 столбцов
                        // и является простой оберткой для вложенного контента
                        <div className="section-menu__column-wrapper" key={index}>
                            {content.map((theme) => (
                                <Column
                                    key={theme.item.id}
                                    theme={theme.item}
                                    tooltipDescriptionId={isActualThemes ? tooltipDescriptions[index] : undefined}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps & OwnProps): StoreProps => {
    const {
        location: { search },
        match: {
            params: { themeId: matchThemeId, subject, classId },
        },
        isActualThemes,
    } = ownProps;
    const query = qs.parse(search);
    const themeId = Number(matchThemeId);
    const currentTeam = getCurrentClass(storeState, { classId });
    const grade = currentTeam?.level || Number(query.grade) || null;
    const courseId = getCurrentYearCourseId(storeState);
    let menuThemes;
    if (isActualThemes) {
        menuThemes = themesSelectors.getActualThemesTreeByCourseId(storeState, { courseId, subject });
    } else {
        const rootThemeId = themesSelectors.getRootThemeByListTheme(storeState, { subject, grade, themeId })?.id;

        menuThemes = themesSelectors.getThemesTree(storeState, { themeId: rootThemeId, subject, grade });
    }

    return {
        menuThemes,
    };
};

const component = mediaQueryResolver(
    [],
    BREAKPOINTS,
    SCREEN_QUERY
)(withRouterPath(connect(mapStateToProps)(SectionMenu))) as React.ComponentType<OwnProps>;

component.displayName = 'SectionMenu';

export default component;
